import { ErrorProps } from '@components/error/src/error.types';
import classNames from 'classnames';

export const Error = ({ dataTestId, children, className = 'mt-1' }: ErrorProps) => {
  return (
    // eslint-disable-next-line
    <p data-testid={dataTestId} className={classNames(className, 'text-left text-critical-no-bg text-body-xs')}>
      {children}
    </p>
  );
};
